import styled from 'styled-components';

export const InputIconSC = styled.div`
  width: 36px;
  height: 36px;

  display: flex;
  align-items: center;
  justify-content: center;
`;
